import Heading from "components/ui/Heading/Heading";
import PropTypes from "prop-types";
import AddButton from "components/ui/Button/AddButton/AddButton";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { LLM_DOCUMENT_CREATE_PERMISSION } from "components/dashboard/TrainSAM/SAM/LLMDocumentation/permissions";

const QaDocumentationHeader = ({
    toggleModal,
}) => {
    return (
        <>
            <Heading
                headingText={"LLM Documentation"}
                headingSubText={"Add & change your LLM Documentation"}
            />
            <div className='issues-heading'>
                <div>
                </div>
                <div>
                    <ComponentAccessControl
                        baseResources={LLM_DOCUMENT_CREATE_PERMISSION}>
                        <AddButton
                            btnText='Create New LLM Document'
                            onClick={toggleModal}
                        />
                    </ComponentAccessControl>
                </div>
            </div>
        </>
    );
};

QaDocumentationHeader.prototypes = {
    getIssues: PropTypes.func.isRequired,
    setSearchValue: PropTypes.func.isRequired,
    issues: PropTypes.array.isRequired,
    clearSearch: PropTypes.bool,
};

export default QaDocumentationHeader;
